import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { Skeleton } from '@/components/ui';

/** No data renders before a valid session. Deep links bounce to /login and return after sign-in. */
export function ProtectedRoute() {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'loading') {
    return (
      <div role="status" aria-label="Checking your session" className="grid min-h-screen place-items-center">
        <Skeleton className="h-8 w-48" />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <Outlet />;
}
